module.exports = __webpack_public_path__ + "img/dk_normal.20ef1d8e.png";